import { useLocation, useNavigate } from "react-router-dom";
import { WbHeaderBar, WbHeaderNavigationItem } from "@workbench/react";
import NotificationBell from "./NotificationBell";
import UserProfileMenu from "./UserProfileMenu";
import { requestAppNavigation } from "../../utils/navigationGuard";
import "./Header.css";

const NAV_ITEMS = [
  { href: "/", label: "Home" },
  { href: "/contracts", label: "Contracts" },
  { href: "/performance", label: "Performance" },
  { href: "/cost-management", label: "Cost Management" },
];

const Header: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  function handleNavigation(event: React.MouseEvent, href: string) {
    event.preventDefault();
    if (requestAppNavigation(href)) navigate(href);
  }

  return (
    <div data-on="main">
      <WbHeaderBar className="app-header-bar" starLabel="eCON Pulse" starHref="/">
        {NAV_ITEMS.map((item) => (
          <WbHeaderNavigationItem
            key={item.href}
            slot="desktop-meta"
            active={(location.pathname === item.href || undefined) as never}
            onClick={(event: React.MouseEvent) =>
              handleNavigation(event, item.href)
            }
            href={item.href}
          >
            {item.label}
          </WbHeaderNavigationItem>
        ))}

        <div slot="desktop-meta" className="header-actions">
          <NotificationBell />
          <UserProfileMenu />
        </div>
      </WbHeaderBar>
    </div>
  );
};

export default Header;
